<template>
    <div id="logs_report_builder_history_page" class="container-fluid">
        <h4 class="margin-left10">Client: {{ client.name }}</h4>

        <div class="modal fade" id="view_report_builder_history" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-xxl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-center w-100">{{ selected_change.date }}<b v-if="previous_change.date" class="margin-x5">VS</b>{{ previous_change.date }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="row">
                            <div class="col-6 selected-change">
                                <div class="builder-elements">
                                    <div v-for="(element, index) in selected_change.data" class="margin-top15" :class="compareSide1(element, index)">
                                        <span class="badge badge-secondary">Moved</span>
                                        <span class="badge badge-success">New / Updated</span>

                                        <div>
                                            <h6 v-if="!/^Element_[0-9]{13}$/.test(element.name)" class="pull-left">{{ element.name }}</h6>
                                        </div>

                                        <div class="report-element-preview text-center">
                                            <img :src="$store.state.app_url + 'images/report_element_preview/' + element.element_abbreviation + '.jpg'">
                                        </div>

                                        <div class="selected-metrics margin-top20">
                                            <template v-if="element.element_abbreviation === 'social_kpi' || element.element_abbreviation === 'social_campaign_details'">
                                                <div v-if="!!element.metrics_1 && element.metrics_1.length > 0">
                                                    <h6>Instagram</h6>
                                                    <b class="margin-right20" v-for="metric in element.metrics_1">
                                                        <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                        {{ metric.new_metric_name || metric.metric_name }}
                                                    </b>
                                                </div>

                                                <div v-if="!!element.metrics_2 && element.metrics_2.length > 0" class="margin-top25">
                                                    <h6>Facebook</h6>
                                                    <b class="margin-right20" v-for="metric in element.metrics_2">
                                                        <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                        {{ metric.new_metric_name || metric.metric_name }}
                                                    </b>
                                                </div>

                                                <div v-if="element.configurations">
                                                    <hr class="margin-top10 margin-bottom15">

                                                    <div v-for="(value, configId) in element.configurations">
                                                        <span v-if="_.find(element_configurations, {id: parseInt(configId)}).selector_type_id === 1">
                                                            <span>{{ _.find(element_configurations, {id: parseInt(configId)}).name }}</span>
                                                            <i class="fa fa-check text-success" aria-hidden="true"></i>
                                                        </span>

                                                        <span v-if="_.find(element_configurations, {id: parseInt(configId)}).selector_type_id === 2">
                                                            <span>{{ _.find(element_configurations, {id: parseInt(configId)}).name }}</span>
                                                            <span> : {{ value }}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else-if="['triple_table_grouping', 'double_table_grouping', 'single_table_grouping'].indexOf(element.element_abbreviation) === -1">
                                                <b class="margin-right20" v-for="metric in element.metrics">
                                                    <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                    {{ metric.new_metric_name || metric.metric_name }} ({{ metric.data_source_abbr }})
                                                </b>

                                                <div v-if="element.configurations">
                                                    <hr class="margin-top10 margin-bottom15">

                                                    <div v-for="(value, configId) in element.configurations">
                                                        <span v-if="_.find(element_configurations, {id: parseInt(configId)}).selector_type_id === 1">
                                                            <span>{{ _.find(element_configurations, {id: parseInt(configId)}).name }}</span>
                                                            <i class="fa fa-check text-success" aria-hidden="true"></i>
                                                        </span>

                                                        <span v-if="_.find(element_configurations, {id: parseInt(configId)}).selector_type_id === 2">
                                                            <span>{{ _.find(element_configurations, {id: parseInt(configId)}).name }}</span>
                                                            <span> : {{ value }}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else>
                                                <div v-if="!!element.metrics_1 && element.reporting_table_type_1">
                                                    <h6>{{ element.table_name_1 }} - {{ element.reporting_table_type_1 }}</h6>
                                                    <b class="margin-left20" v-for="metric in element.metrics_1">
                                                        <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                        {{ metric.new_metric_name || metric.metric_name }} ({{ metric.data_source_abbr }})
                                                    </b>
                                                    <div v-if="element.reporting_table_type_configurations_1" class="margin-top10 margin-left20">
                                                        <hr class="margin-y10">

                                                        <div v-for="(value, configName) in element.reporting_table_type_configurations_1">
                                                            <span v-if="_.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_1}).selector_type_id === 1">
                                                                <span>{{ _.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_1}).name }}</span>
                                                                <i class="fa fa-check text-success" aria-hidden="true"></i>
                                                            </span>

                                                            <span v-if="_.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_1}).selector_type_id === 2">
                                                                <span>{{ _.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_1}).name }}</span>
                                                                <span> : {{ value }}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-if="!!element.metrics_2 && element.reporting_table_type_2" class="margin-top25">
                                                    <h6>{{ element.table_name_2 }} - {{ element.reporting_table_type_2 }}</h6>
                                                    <b class="margin-left20" v-for="metric in element.metrics_2">
                                                        <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                        {{ metric.new_metric_name || metric.metric_name }} ({{ metric.data_source_abbr }})
                                                    </b>
                                                    <div v-if="element.reporting_table_type_configurations_2" class="margin-top10 margin-left20">
                                                        <hr class="margin-y10">

                                                        <div v-for="(value, configName) in element.reporting_table_type_configurations_2">
                                                            <span v-if="_.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_2}).selector_type_id === 1">
                                                                <span>{{ _.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_2}).name }}</span>
                                                                <i class="fa fa-check text-success" aria-hidden="true"></i>
                                                            </span>

                                                            <span v-if="_.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_2}).selector_type_id === 2">
                                                                <span>{{ _.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_2}).name }}</span>
                                                                <span> : {{ value }}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-if="element.reporting_table_type_3" class="margin-top25">
                                                    <h6>{{ element.table_name_3 }} - {{ element.reporting_table_type_3 }}</h6>
                                                    <b class="margin-left20" v-for="metric in element.metrics_3">
                                                        <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                        {{ metric.new_metric_name || metric.metric_name }} ({{ metric.data_source_abbr }})
                                                    </b>
                                                    <div v-if="element.reporting_table_type_configurations_3" class="margin-top10 margin-left20">
                                                        <hr class="margin-y10">

                                                        <div v-for="(value, configName) in element.reporting_table_type_configurations_3">
                                                            <span v-if="_.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_3}).selector_type_id === 1">
                                                                <span>{{ _.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_3}).name }}</span>
                                                                <i class="fa fa-check text-success" aria-hidden="true"></i>
                                                            </span>

                                                            <span v-if="_.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_3}).selector_type_id === 2">
                                                                <span>{{ _.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_3}).name }}</span>
                                                                <span> : {{ value }}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-if="element.configurations">
                                                    <hr class="margin-top10 margin-bottom15">

                                                    <div v-for="(value, configId) in element.configurations">
                                                        <span v-if="_.find(element_configurations, {id: parseInt(configId)}).selector_type_id === 1">
                                                            <span>{{ _.find(element_configurations, {id: parseInt(configId)}).name }}</span>
                                                            <i class="fa fa-check text-success" aria-hidden="true"></i>
                                                        </span>

                                                        <span v-if="_.find(element_configurations, {id: parseInt(configId)}).selector_type_id === 2">
                                                            <span>{{ _.find(element_configurations, {id: parseInt(configId)}).name }}</span>
                                                            <span> : {{ value }}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-6">
                                <div class="builder-elements">
                                    <div v-for="(element, index) in previous_change.data" class="margin-top15" :class="compareSide2(element, index)">
                                        <span class="badge badge-secondary">Moved</span>
                                        <span class="badge badge-success">New / Updated</span>

                                        <div>
                                            <h6 v-if="!/^Element_[0-9]{13}$/.test(element.name)" class="pull-left">{{ element.name }}</h6>
                                        </div>

                                        <div class="report-element-preview text-center">
                                            <img :src="$store.state.app_url + 'images/report_element_preview/' + element.element_abbreviation + '.jpg'">
                                        </div>

                                        <div class="selected-metrics margin-top20">
                                            <template v-if="element.element_abbreviation === 'social_kpi' || element.element_abbreviation === 'social_campaign_details'">
                                                <div v-if="!!element.metrics_1 && element.metrics_1.length > 0">
                                                    <h6>Instagram</h6>
                                                    <b class="margin-right20" v-for="metric in element.metrics_1">
                                                        <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                        {{ metric.new_metric_name || metric.metric_name }}
                                                    </b>
                                                </div>

                                                <div v-if="!!element.metrics_2 && element.metrics_2.length > 0" class="margin-top25">
                                                    <h6>Facebook</h6>
                                                    <b class="margin-right20" v-for="metric in element.metrics_2">
                                                        <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                        {{ metric.new_metric_name || metric.metric_name }}
                                                    </b>
                                                </div>

                                                <div v-if="element.configurations">
                                                    <hr class="margin-top10 margin-bottom15">

                                                    <div v-for="(value, configId) in element.configurations">
                                                        <span v-if="_.find(element_configurations, {id: parseInt(configId)}).selector_type_id === 1">
                                                            <span>{{ _.find(element_configurations, {id: parseInt(configId)}).name }}</span>
                                                            <i class="fa fa-check text-success" aria-hidden="true"></i>
                                                        </span>

                                                        <span v-if="_.find(element_configurations, {id: parseInt(configId)}).selector_type_id === 2">
                                                            <span>{{ _.find(element_configurations, {id: parseInt(configId)}).name }}</span>
                                                            <span> : {{ value }}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else-if="['triple_table_grouping', 'double_table_grouping', 'single_table_grouping'].indexOf(element.element_abbreviation) === -1">
                                                <b class="margin-right20" v-for="metric in element.metrics">
                                                    <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                    {{ metric.new_metric_name || metric.metric_name }} ({{ metric.data_source_abbr }})
                                                </b>

                                                <div v-if="element.configurations">
                                                    <hr class="margin-top10 margin-bottom15">

                                                    <div v-for="(value, configId) in element.configurations">
                                                        <span v-if="_.find(element_configurations, {id: parseInt(configId)}).selector_type_id === 1">
                                                            <span>{{ _.find(element_configurations, {id: parseInt(configId)}).name }}</span>
                                                            <i class="fa fa-check text-success" aria-hidden="true"></i>
                                                        </span>

                                                        <span v-if="_.find(element_configurations, {id: parseInt(configId)}).selector_type_id === 2">
                                                            <span>{{ _.find(element_configurations, {id: parseInt(configId)}).name }}</span>
                                                            <span> : {{ value }}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else>
                                                <div v-if="!!element.metrics_1 && element.reporting_table_type_1">
                                                    <h6>{{ element.table_name_1 }} - {{ element.reporting_table_type_1 }}</h6>
                                                    <b class="margin-left20" v-for="metric in element.metrics_1">
                                                        <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                        {{ metric.new_metric_name || metric.metric_name }} ({{ metric.data_source_abbr }})
                                                    </b>
                                                    <div v-if="element.reporting_table_type_configurations_1" class="margin-top10 margin-left20">
                                                        <hr class="margin-y10">

                                                        <div v-for="(value, configName) in element.reporting_table_type_configurations_1">
                                                            <span v-if="_.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_1}).selector_type_id === 1">
                                                                <span>{{ _.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_1}).name }}</span>
                                                                <i class="fa fa-check text-success" aria-hidden="true"></i>
                                                            </span>

                                                            <span v-if="_.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_1}).selector_type_id === 2">
                                                                <span>{{ _.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_1}).name }}</span>
                                                                <span> : {{ value }}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-if="!!element.metrics_2 && element.reporting_table_type_2" class="margin-top25">
                                                    <h6>{{ element.table_name_2 }} - {{ element.reporting_table_type_2 }}</h6>
                                                    <b class="margin-left20" v-for="metric in element.metrics_2">
                                                        <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                        {{ metric.new_metric_name || metric.metric_name }} ({{ metric.data_source_abbr }})
                                                    </b>
                                                    <div v-if="element.reporting_table_type_configurations_2" class="margin-top10 margin-left20">
                                                        <hr class="margin-y10">

                                                        <div v-for="(value, configName) in element.reporting_table_type_configurations_2">
                                                            <span v-if="_.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_2}).selector_type_id === 1">
                                                                <span>{{ _.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_2}).name }}</span>
                                                                <i class="fa fa-check text-success" aria-hidden="true"></i>
                                                            </span>

                                                            <span v-if="_.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_2}).selector_type_id === 2">
                                                                <span>{{ _.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_2}).name }}</span>
                                                                <span> : {{ value }}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-if="element.reporting_table_type_3" class="margin-top25">
                                                    <h6>{{ element.table_name_3 }} - {{ element.reporting_table_type_3 }}</h6>
                                                    <b class="margin-left20" v-for="metric in element.metrics_3">
                                                        <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                        {{ metric.new_metric_name || metric.metric_name }} ({{ metric.data_source_abbr }})
                                                    </b>
                                                    <div v-if="element.reporting_table_type_configurations_3" class="margin-top10 margin-left20">
                                                        <hr class="margin-y10">

                                                        <div v-for="(value, configName) in element.reporting_table_type_configurations_3">
                                                            <span v-if="_.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_3}).selector_type_id === 1">
                                                                <span>{{ _.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_3}).name }}</span>
                                                                <i class="fa fa-check text-success" aria-hidden="true"></i>
                                                            </span>

                                                            <span v-if="_.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_3}).selector_type_id === 2">
                                                                <span>{{ _.find(reporting_table_type_configurations, {name: configName, reporting_table_type: element.reporting_table_type_3}).name }}</span>
                                                                <span> : {{ value }}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-if="element.configurations">
                                                    <hr class="margin-top10 margin-bottom15">

                                                    <div v-for="(value, configId) in element.configurations">
                                                        <span v-if="_.find(element_configurations, {id: parseInt(configId)}).selector_type_id === 1">
                                                            <span>{{ _.find(element_configurations, {id: parseInt(configId)}).name }}</span>
                                                            <i class="fa fa-check text-success" aria-hidden="true"></i>
                                                        </span>

                                                        <span v-if="_.find(element_configurations, {id: parseInt(configId)}).selector_type_id === 2">
                                                            <span>{{ _.find(element_configurations, {id: parseInt(configId)}).name }}</span>
                                                            <span> : {{ value }}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <v-client-table :data="tableData" :columns="columns" :options="options">
            <div slot="actions" slot-scope="props" class="text-right">
                <button @click="viewChange(props.row.id, props.row.report_id)" type="button" class="btn btn-info reverse">View</button>
            </div>
        </v-client-table>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        data() {
            return {
                client: {},
                selected_change: {},
                previous_change: {},
                element_configurations: [],
                reporting_table_type_configurations: [],
                columns: ['report_name', 'changed_by', 'date', 'actions'],
                tableData: [],
                options: {
                    headings: {
                        report_name: 'Report Name',
                        changed_by:  'Changed By',
                        date:        'Date of Change',
                        actions:     ''
                    },
                    sortable: ['report_name', 'changed_by', 'date'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} logs|{count} logs|One log',
                        filter: '',
                        filterPlaceholder: 'Search logs...',
                        noResults: 'No matching logs'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get(`/api/clients/${this.$route.params.id}`),
                    axios.get(`/api/logs/report-builder-history/client/${this.$route.params.id}`),
                    axios.get('/api/element-configurations'),
                    axios.get('/api/reporting-table-type-configurations')
                ])
                .then(axios.spread((client, logs, elementConfigurations, reportingTableTypeConfigurations) => {
                    this.client                              = client.data;
                    this.tableData                           = logs.data;
                    this.element_configurations              = elementConfigurations.data;
                    this.reporting_table_type_configurations = reportingTableTypeConfigurations.data;
                }));
            },

            viewChange(id, reportId) {
                $('#view_report_builder_history').modal('show');

                this.selected_change = {};
                this.previous_change = {};

                const reportChanges = _.filter(this.tableData, {report_id: reportId});
                const index         = _.findIndex(reportChanges, {id: id});

                if (index > -1) {
                    this.selected_change = reportChanges[index];
                    this.previous_change = reportChanges[index + 1] || {};
                }
            },

            compareSide1(element, index) {
                if (this.previous_change.data) {
                    let moved = false;

                    _.each(this.previous_change.data, (el, i) => {
                        if (i !== index && _.isEqualWith(element, el, (a, b, key) => { if (key === 'report_element_id') { return true; } })) {
                            moved = true;
                        }
                    });

                    if (moved) {
                        return 'moved';
                    }

                    if (!_.isEqualWith(element, this.previous_change.data[index], (a, b, key) => { if (key === 'report_element_id') { return true; } })) {
                        return 'updated-or-new';
                    }
                }
            },

            compareSide2(element, index) {
                if (this.selected_change.data) {
                    let moved = false;

                    _.each(this.selected_change.data, (el, i) => {
                        if (i !== index && _.isEqualWith(element, el, (a, b, key) => { if (key === 'report_element_id') { return true; } })) {
                            moved = true;
                        }
                    });

                    if (moved) {
                        return 'moved';
                    }

                    if (!_.isEqualWith(element, this.selected_change.data[index], (a, b, key) => { if (key === 'report_element_id') { return true; } })) {
                        return 'updated-or-new';
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    #logs_report_builder_history_page {
        .modal-header {
            position: relative;

            button {
                position: absolute;
                right: 2rem;
            }
        }

        .modal-body {
            .selected-change {
                border-right: .2rem dashed #cccccc;
            }
        }

        .builder-elements {
            .badge {
                display: none;
                padding: .5rem .5rem .3rem;
            }

            > div.moved .badge-secondary {
                display: block;
                position: absolute;
                top: -0.9rem;
                left: 46.5%;
            }

            > div.updated-or-new .badge-success {
                display: block;
                position: absolute;
                top: -0.9rem;
                left: 44%;
                color: white;
            }

            .report-element-preview {
                clear: both;
                padding: 1rem 0 0;

                img {
                    max-height: 12rem;
                    max-width: 80%;
                }
            }

            #element_options {
                border: none!important;
                padding: 0;
                box-shadow: none!important;
            }

            .dropdown-menu {
                box-shadow: 0 0 0.3rem #73b9cf;
                border: none!important;
            }

            .dropdown-toggle::after {
                display: none!important;
            }

            > div {
                background-color: white;
                padding: 1.5rem;
                border: .1rem solid #73b9cf;
                margin-bottom: 1rem;
                position: relative;

                &.moved {
                    border: .2rem dashed #049bdd;
                }

                &.updated-or-new {
                    border: .2rem dashed #a6cf71;
                }
            }

            .element-options-icon {
                font-size: 2.8rem;
                color: #37a8cd;
                margin-top: -1rem;
                cursor: pointer;
            }

            .selected-metrics {
                font-size: 1.2rem;

                .fa-line-chart {
                    color: #37a8cd;
                }

                b {
                    font-weight: 500;
                }
            }
        }
    }
</style>
